import { SchemaPath, validate } from '@angular/forms/signals';

const HAS_NUMBER = /\d/;
const HAS_LETTER = /[a-zA-Z]/;
const HAS_SPECIAL_CHARACTER = /[!@#$%^&*()_+\-=[\]{}\\|;':",./<> ?`]/;

/** Password policy: at least one digit, one letter and one special character. */
export const isPasswordValid = (password: string): boolean =>
  HAS_NUMBER.test(password) && HAS_LETTER.test(password) && HAS_SPECIAL_CHARACTER.test(password);

/**
 * Signal Forms rule: the password satisfies {@link isPasswordValid}. Empty values pass (combine with `required`).
 * Error kind: `password`.
 */
export function passwordStrength(path: SchemaPath<string>, options: { message?: string } = {}): void {
  validate(path, ({ value }) =>
    !value() || isPasswordValid(value()) ? undefined : { kind: 'password', message: options.message }
  );
}

/**
 * Signal Forms rule: `confirmation` equals `password`. Reported on the confirmation field only and re-evaluated
 * reactively when either value changes. Empty confirmation passes (combine with `required`).
 * Error kind: `passwordsMustMatch`.
 */
export function passwordsMatch(
  confirmation: SchemaPath<string>,
  password: SchemaPath<string>,
  options: { message?: string } = {}
): void {
  validate(confirmation, ({ value, valueOf }) =>
    !value() || value() === valueOf(password) ? undefined : { kind: 'passwordsMustMatch', message: options.message }
  );
}
